import { ApplicationRole } from "../types";

export function getAppRoleKey(role: ApplicationRole): string {
    return `${role.applicationRoleCode}-${role.applicationInstanceCode}-${role.productCode}`;
}
